import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Calendar, TestTube2, CheckCircle2 } from 'lucide-react';
import { BookingModal } from '@/components/BookingModal';
import { HeroSlider } from '@/components/HeroSlider';

export const Hero = () => {
  const [showBookingModal, setShowBookingModal] = useState(false);

  const partners = [
    { name: 'Dr. Lal PathLabs', testId: 'partner-badge-dr-lal-pathlabs' },
    { name: 'Oncquest', testId: 'partner-badge-oncquest' },
  ];

  const handleBookTest = () => {
    const message = encodeURIComponent(
      'Hi Ushakiran Medicos, I want to book a home collection for a lab test. Please help me.'
    );
    window.open(`https://wa.me/919007667528?text=${message}`, '_blank');
  };

  return (
    <>
      <section
        id="home"
        data-testid="hero-section"
        className="relative min-h-[90vh] flex items-center justify-center overflow-hidden px-4 sm:px-6 lg:px-8 py-12 sm:py-16"
      >
        {/* Background Image Slider */}
        <HeroSlider />
        
        {/* Content */}
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="text-center space-y-8 sm:space-y-10">
            {/* Badge */}
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-rose-600 to-pink-600 text-white text-sm font-semibold shadow-lg">
              <CheckCircle2 className="w-4 h-4 mr-2" />
              Estd. 2009 - Trusted Healthcare Partner
            </div>

            {/* Main Headline */}
            <h1
              data-testid="hero-main-headline"
              className="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.15] font-['Outfit'] px-4 drop-shadow-2xl"
            >
              World class service at your{' '}
              <span className="text-rose-400">Door-Step</span>
              <br />
              <span className="text-2xl sm:text-4xl lg:text-5xl font-semibold text-white/95 mt-4 block">
                Feel The Difference
              </span>
            </h1>

            {/* Subtext */}
            <p className="text-sm sm:text-base text-white/90 max-w-2xl mx-auto leading-relaxed px-4 drop-shadow-lg">
              Experience premium healthcare services with home sample collection, accurate diagnostics,
              and expert medical consultation - all at your convenience.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 px-4">
              <Button
                data-testid="hero-book-test-button"
                onClick={handleBookTest}
                size="lg"
                className="w-full sm:w-auto bg-gradient-to-r from-rose-600 to-pink-600 hover:shadow-xl hover:shadow-rose-500/50 text-white font-semibold px-8 py-6 text-base transition-all duration-300"
              >
                <TestTube2 className="w-5 h-5 mr-2" />
                Book a Test
              </Button>
              <Button
                data-testid="hero-book-appointment-button"
                onClick={() => setShowBookingModal(true)}
                size="lg"
                variant="outline"
                className="w-full sm:w-auto border-2 border-rose-600 text-rose-600 hover:bg-rose-600 hover:text-white font-semibold px-8 py-6 text-base transition-all duration-300"
              >
                <Calendar className="w-5 h-5 mr-2" />
                Book an Appointment
              </Button>
            </div>

            {/* Trust Badges */}
            <div data-testid="trust-partners-badges-container" className="pt-8 sm:pt-12">
              <p className="text-xs sm:text-sm font-medium tracking-wide text-white/80 uppercase mb-6 drop-shadow-lg">
                Authorized Partner of
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-2xl mx-auto">
                {partners.map((partner) => (
                  <div
                    key={partner.testId}
                    data-testid={partner.testId}
                    className="bg-white border border-slate-200/80 rounded-2xl px-4 py-6 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_12px_32px_rgba(233,30,99,0.12)] transition-all duration-300 hover:border-rose-300"
                  >
                    <div className="flex items-center justify-center h-12">
                      <p className="text-sm font-semibold text-slate-700 text-center leading-tight">
                        {partner.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingModal
        isOpen={showBookingModal}
        onClose={() => setShowBookingModal(false)}
        bookingType="global"
      />
    </>
  );
};